import type { ComponentProps } from "react";

const LightningIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5691 6.93117C11.5363 6.87319 11.4886 6.82497 11.4311 6.79141C11.3735 6.75786 11.308 6.74018 11.2414 6.74017H6.30627L7.13366 0.418432C7.14254 0.333826 7.12268 0.248693 7.0773 0.176742C7.03191 0.10479 6.96363 0.0502068 6.88344 0.0217797C6.80326 -0.00664739 6.71585 -0.00726388 6.63528 0.0200295C6.5547 0.0473229 6.48566 0.100938 6.43926 0.172242L0.437639 10.6868C0.402544 10.7439 0.383309 10.8093 0.381917 10.8763C0.380526 10.9433 0.397028 11.0095 0.429724 11.068C0.462419 11.1265 0.510124 11.1752 0.567919 11.2091C0.625714 11.243 0.691507 11.2609 0.758516 11.2609H5.61988L4.96419 17.5921C4.95775 17.6765 4.97969 17.7605 5.02652 17.8309C5.07335 17.9013 5.14238 17.954 5.22263 17.9807C5.30289 18.0073 5.38975 18.0064 5.46939 17.978C5.54904 17.9496 5.61689 17.8953 5.66217 17.8239L11.5646 7.31044C11.5988 7.25327 11.6173 7.18805 11.6181 7.12142C11.6189 7.05479 11.602 6.98914 11.5691 6.93117Z"
        fill={props.fill || "#7D7D7D"}
      />
    </svg>
  );
};

export default LightningIcon;
